
import Footer from "@/components/layout/Footer";
import Navbar from "@/components/layout/Navbar";
import HeaderWithBackButton from "@/components/common/HeaderWithBackButton";
import SEOHead from "@/components/common/SEOHead";
import { SITE_URL } from "@/lib/constants/urls";

const Guidelines = () => {
  return (
    <>
      <SEOHead
        title="Community Guidelines | PaperVerse"
        description="How to submit, review and write on PaperVerse: submission standards, constructive reviewing, and the rules for AI-assisted writing and AI reviews."
        canonicalUrl={`${SITE_URL}/guidelines`}
        keywords="research community guidelines, peer review etiquette, AI-assisted writing policy, AI authorship disclosure"
      />

      <div className="min-h-screen flex flex-col">
        <Navbar />
        
        <main className="flex-1 max-w-4xl mx-auto w-full px-4 py-12">
          <HeaderWithBackButton title="Community Guidelines" />

          
          <div className="prose dark:prose-invert max-w-none">
            <p>
              At PaperVerse, we believe in fostering a supportive, constructive, and inclusive environment for researchers. 
              These guidelines are designed to help our community thrive and ensure that PaperVerse remains a valuable resource for all.
            </p>
            
            <h2>Submission Guidelines</h2>
            <p>
              When submitting papers to PaperVerse, please ensure that:
            </p>
            <ul>
              <li>Your submission represents original work</li>
              <li>You have properly credited all sources and contributors</li>
              <li>You have the right to share the work on PaperVerse</li>
              <li>The content adheres to ethical research standards</li>
            </ul>
            
            <h2>Reviewing Guidelines</h2>
            <p>
              When reviewing others' work:
            </p>
            <ul>
              <li>Provide constructive, actionable feedback</li>
              <li>Focus on the content rather than the author</li>
              <li>Be specific in your comments</li>
              <li>Acknowledge the positive aspects as well as areas for improvement</li>
            </ul>
            
            <h2>Community Interaction</h2>
            <p>
              When interacting with other members of the PaperVerse community:
            </p>
            <ul>
              <li>Be respectful and professional</li>
              <li>Engage in good-faith discussions</li>
              <li>Value diverse perspectives and experiences</li>
              <li>Help create a welcoming environment for researchers at all stages</li>
            </ul>

            <h2>AI-Assisted Writing</h2>
            <p>
              PaperVerse Writer can draft and revise text in your manuscript. When you use it:
            </p>
            <ul>
              <li>You are the author. You are responsible for every claim, number and formulation that ends up in your paper</li>
              <li>Verify every AI-suggested citation against the original source before you submit — models can state references inaccurately or invent them</li>
              <li>Disclose AI assistance where your target journal, conference or institution requires it</li>
              <li>Do not paste substantial third-party copyrighted text into the editor for the purpose of reproducing it</li>
              <li>Do not use the assistant to fabricate data, results or attributions</li>
            </ul>

            <h2>AI Reviews</h2>
            <p>
              AI reviews are machine-generated feedback, not peer review:
            </p>
            <ul>
              <li>Treat them as a first reader that helps you find weaknesses early, not as a verdict on your work</li>
              <li>Never present an AI review as a human peer review, and never submit one to a venue as if it were</li>
              <li>Report reviews that are abusive, discriminatory or clearly wrong so we can improve the system</li>
            </ul>
          </div>

        </main>
        
        <Footer />
      </div>
    </>
  );
};

export default Guidelines;
